import tw from 'tailwind-styled-components'
import {IconButton} from '@components/common/base/buttons'

export const TwTasksList = tw.div`
  tasks-list
  w-full
  bg-primary
  pl-12
  pb-24
  pr-16
  min-w-[1052px]
  
  flex
  flex-col
  gap-24
`

export const TwAddListBtnWrapper = tw.div`
  p-16
  pl-28
  flex
  gap-12
`

export const TwAddNewList = tw.div`
  px-16
  pt-16
  pb-32
`

export const TwListHeader = tw.div`
  group
  py-8
  pl-8
  rounded-8
  pr-16
  flex
  items-center
  justify-between
`

export const TwStub = tw.div`
  text-secondary
  pl-54
  py-12
`

export const TwHeaderLeftArea = tw.div`
  flex
  items-center
  gap-24
`

export const TwHeaderFunctions = tw.div`
  flex
  items-center
  gap-8
`

export const TwTaskListInner = tw.div`
  py-8
`

export const TwTitleWrapper = tw.div`
  flex
  items-center
  gap-8
  cursor-pointer
`

export const TwEditListWrapper = tw.div`
  relative
  flex
  items-center
`

export const TwTitleInnerWrapper = tw.div`
  flex
  items-center
  gap-8
`

export const TwHeaderTitleContainer = tw.div`
  flex
  items-center
  text-primary
  font-semibold
  text-20
  gap-8
`

export const TwHeaderTitleBlock = tw.div`
  flex
  items-center
  gap-8
  flex-nowrap
`

export const TwHeaderTitle = tw.div`
  inline-block
  max-w-[330px]
  truncate
`

export const TwShowMore = tw.div`
  py-12
  px-24
  w-full
`

export const TwAddTaskContainer = tw.div`
  py-12
  px-16
`

export const TwTaskInputWrapper = tw.div`
  py-8
  px-8
  rounded-12
`

export const TwTableSettingsWrapper = tw.div`
  flex
  items-center
  justify-end
  gap-12
`

export const TwTableSettingWrapper = tw.div`
  flex
  items-center
  justify-end
`

export const TwTableSettingOptions = tw.div`
  flex
  flex-col
  bg-primary
  rounded-8
  py-8
  w-[248px]
`

export const TwTableSettingsTitle = tw.div`
  text-14
  font-semibold
  leading-16
  px-12
  pt-4
  pb-8
  text-primary
`

export const TwTableSettingOption = tw.div`
  flex
  items-center
  justify-start
  py-4
  px-12
  text-12
  cursor-pointer
  text-primary
`

export const TwTableSettingOptionLabel = tw.div`
  ml-8
`

export const TwFiltersHeader = tw.div<{
  $hasFilters: boolean
  $expanded: boolean
}>`
  px-16
  h-48
  flex
  items-center
  rounded-t-8
  gap-16
  ${p =>
    p.$hasFilters && p.$expanded ? 'bg-background-secondary' : 'bg-primary'}
`

export const TwTaskListFilters = tw.div`
  flex
  gap-24
  p-16
  rounded-8
  bg-background-secondary
`

export const TwFilter = tw.div<{$maxWidth?: boolean}>`
  flex
  flex-col
  gap-[9px]
  min-w-[136px]
  ${p => (p.$maxWidth ? 'flex-1' : 'max-w-[180px]')}
`

export const TwFilterTitle = tw.div`
  text-secondary
`

export const TwStickersWrappers = tw.div`
  flex
  gap-24
  flex-wrap
  items-baseline
`

export const StickerFiltersWrapper = tw.div`
  flex
  flex-col
  gap-8
  max-w-[180px]
`

export const TwDateRange = tw.div`
  flex
  flex-col
  gap-8
  justify-center
  items-center
  pt-4
`

export const TwStickerFilterDropdown = tw.div`
  flex
  flex-col
  w-[240px]
  py-8
`

export const StickerFilterDropdownTitle = tw.div`
  pt-4
  pb-8
  px-12
  font-semibold
  truncate
  text-secondary
`

export const TwStickerStateRow = tw.div`
  flex
  items-center
  justify-between
  py-4
  px-12
  cursor-pointer
`

export const TwStickerFilterValue = tw.div<{
  $disabled: boolean
  $active: boolean
}>`
  flex
  w-full
  h-[32px]
  py-8
  px-12
  items-center
  rounded-8
  shadow-border-1
  
  ${({$active}) =>
    $active
      ? 'outline outline-1 outline-offset-0 outline-action-default shadow-action-default'
      : 'shadow-grey-l60'}
  
  ${({$disabled}) =>
    $disabled
      ? 'bg-background-disabled text-placeholder cursor-default'
      : 'bg-background-primary cursor-pointer'}
`

export const TwTaskTitleCountBadge = tw.div`
  bg-background-secondary
  rounded-4
  px-6
  py-2
  text-subtitle-xs
  text-secondary
`

export const TwAppliedListTool = tw.div`
  text-body
  text-action-default
`

export const TwIconButton = tw(IconButton)<{
  $isTaskColored?: boolean
  $isCompleted?: boolean
  $isOpen?: boolean
  $forceVisible?: boolean
}>`
  relative
  !w-12 !h-20 flex justify-center items-center border border-solid rounded-[7px]
  hover:!text-action-hover active:!text-action-pressed
  ${({ $isOpen }) => $isOpen ? '' : 'invisible group-hover:visible'}
  ${p => {
    return `hover:!text-action-hover active:!text-action-pressed ${
    p.$isCompleted ? '!text-placeholder-new' : ''
  }`
}}
`

export const TwHeaderConfigGroup = tw.div`
  flex
  gap-4
  items-center
`